export default __webpack_public_path__ + "images/loads-generated-scard-icon.svg";